import React, { createContext, useReducer } from "react";

export const GameDataContext = createContext();

const initialState = {
  data: null,
  user_data: null,
  loading: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "GAME_DATA":
      // console.log("context", action.data)
      return {
        ...state,
        data: action.data,
      };
    case "USER_DATA":
      // console.log("context", action.data)
      return {
        ...state,
        user_data: action.data,
      };
    case "LOADING":
      // console.log("context", action.data)
      return {
        ...state,
        loading: action.data,
      };
    default:
      return state;
  }
}

export const GameDataProvider = ({ children }) => {
  const [gameData, gameDispatch] = useReducer(reducer, initialState);
  const value = { gameData, gameDispatch };
  return (
    <GameDataContext.Provider value={value}>
      {children}
    </GameDataContext.Provider>
  );
};
